/**
 * Samam Poorvam Prayogams Data Module for ahobilam.com-2025
 * Devanagari Sanskrit Text + Tamil Translations (தமிழ் உரை / தாற்பரியம்)
 */

export const SAMAM_POORVAM_DATA = {
  "mangala-dravya": {
    id: "mangala-dravya",
    titleDeva: "प्रातः प्रबोधानन्तरं मङ्गलद्रव्यावलोकनम्",
    titleTamil: "காலை விழிப்பு மற்றும் மங்கள திரவிய தரிசனம்",
    veda: "Samam",
    category: "Poorvam",
    pageNumber: 1,
    content: [
      {
        deva: "प्रातः प्रबोधानन्तरं मङ्गलद्रव्याणि पश्येत् ।",
        tamilTranslit: "ப்ராஃதஃ ப்ரபோதா⁴நந்தரம் மங்க³ளத்³ரவ்யாணி பஶ்யேத் ।",
        tamilMeaning: "காலை தூக்கத்திலிருந்து எழுந்தவுடன் மங்களகரமான பொருட்களைக் கண்டு தரிசிக்க வேண்டும்."
      },
      {
        deva: "सूर्यः सोमो यमः कालः सन्ध्ये भूतान्यहः क्षपा ।\nपवनो दिक्पतिर्भूमिराकाशं खचरामराः ॥",
        tamilTranslit: "ஸூர்யஃ ஸோமோ யமஃ காலஃ ஸந்த்யே பூ⁴தாந்யஹஃ க்ஷபா ।\nபவநோ தி³க்பதிர் பூ⁴மிராகாஶம் க²சராமராஃ ॥",
        tamilMeaning: "சூரியன், சந்திரன், எமன், காலம், சந்தி தேவதைகள், பஞ்சபூதங்கள், பகல், இரவு,\nவாயு, திிக்பாலகர்கள், பூமி, ஆகாசம், தேவர்கள் அனைவரும் நமக்கு சுபத்தை அளிக்கட்டும்."
      },
      {
        deva: "विष्णुं जिष्णुं हरिं देवं केशवं पुरुषोत्तमम् । नामानि स्मरन् उत्तिष्ठेत् सर्वपापप्रणाशनम् ॥",
        tamilTranslit: "விஷ்ணும் ஜிஷ்ணும் ஹரிம் தே³வம் கேஶவம் புருஷோத்தமம் । நாமாநி ஸ்மரன் உத்திஷ்டே²த் ஸர்வபாபப்ரணாஶநம் ॥",
        tamilMeaning: "விஷ்ணு, ஜிஷ்ணு, ஹரி, கேசவன், புருஷோத்தமன் என்னும் பகவானுடைய திருநாமங்களை ஸ்மரணம் செய்தவாறே படுக்கையிலிருந்து எழுந்திருக்க வேண்டும்."
      }
    ]
  },
  "shaucha-danta-snana": {
    id: "shaucha-danta-snana",
    titleDeva: "शौचविधिः दन्तधावनं स्नानम्",
    titleTamil: "சௌச விதி, தந்ததாவனம் மற்றும் ஸ்நான விதி",
    pageNumber: 12,
    content: [
      {
        deva: "शौचं कृत्वा यथाशास्त्रं दन्तधावनमाचरेत् ।",
        tamilTranslit: "ஶௌசம் க்ரு'த்வா யதா²ஶாஸ்த்ரம் த³ந்ததா⁴வநமாசரேத் ।",
        tamilMeaning: "சாஸ்திரப்படி சௌச விதிகளை முடித்த பின்னர், பல் துலக்குதலைச் செய்ய வேண்டும்."
      },
      {
        deva: "आयुर्बलं यशोधैर्यं तेजः प्रज्ञां च मेधया । तनोतु काष्ठं दन्तानां कुर्यान्मे दन्तधावनम् ॥",
        tamilTranslit: " ஆயுர்பலம் யஶோதை⁴ர்யம் தேஜஃ ப்ரஜ்ஞாம் ச மேத⁴யா । தநோது காஷ்ட²ம் த³ந்தாநாம் குர்யான்மே த³ந்ததா⁴வநம் ॥",
        tamilMeaning: "ஆயுள், பலம், புகழ், தைரியம், தேஜஸ், அறிவு ஆகியவற்றைப் பெருக்கும் பொருட்டு தந்ததாவனம் செய்கிறேன்."
      },
      {
        deva: "गङ्गे च यमुने चैव गोदावरि सरस्वति । नर्मदे सिन्धु कावेरि जलेऽस्मिन सन्निधिं कुरु ॥",
        tamilTranslit: "க³ங்கே³ ச யமுநே சைவை கோ³தா³வரி ஸரஸ்வதி । நர்மதே³ ஸிந்து⁴ காவேரி ஜலேऽஸ்மின் ஸந்நிதி⁴ம் குரு ॥",
        tamilMeaning: "கங்கை, யமுனை, கோதாவரி, சரஸ்வதி, நர்மதை, சிந்து, காவேரி ஆகிய புண்ணிய தீர்த்தங்கள் இந்த ஸ்நான நீரில் எழுந்தருளட்டும்."
      }
    ]
  },
  "brahmayajna-tarpana": {
    id: "brahmayajna-tarpana",
    titleDeva: "ब्रह्मयज्ञः तर्पणकालः",
    titleTamil: "பிரம்மயக்ஞம் மற்றும் தர்பண காலம்",
    pageNumber: 4,
    content: [
      {
        deva: "अथातो ब्रह्मयज्ञं व्याख्यास्यामः । प्राच्यां दिशि सुचौ देशे आसीनः ।",
        tamilTranslit: "அதா²தோ ப்³ரஹ்மயஜ்ஞம் வ்யாக்யாஸ்யாமஃ । ப்ராச்யாம் தி³ஶி ஸுசௌ தே³ஶே ஆஸீநஃ ।",
        tamilMeaning: "இனி பிரம்மயக்ஞ விதியைக் கூறுகிறோம். கிழக்கு நோக்கிய தூய்மையான இடத்தில் அமர்ந்து ஆசமனம் செய்து தொடங்க வேண்டும்."
      },
      {
        deva: "विद्युदसि विद्य मे पाप्मानमृतात् सत्यमुपैमि ।",
        tamilTranslit: "வித்³யுத³ஸி வித்³ய மே பாப்மாநம்ரு'தாத் ஸத்யமுபைமி ।",
        tamilMeaning: "நீ மின்னலைப் போன்ற ஒளி மிக்கவன்; என்னுடைய பாபங்களைப் போக்கி சத்தியப் பாதையில் என்னைச் செலுத்துவாயாக."
      },
      {
        deva: "देवांस्तर्पयामि । ऋषींस्तर्पयामि । पितॄंस्तर्पयामि ॥",
        tamilTranslit: "தே³வாம்ஸ்தர்பயாமி । ரு'ஷீம்ஸ்தர்பயாமி । பித்ரூம்ஸ்தர்பயாமி ॥",
        tamilMeaning: "தேவர்களைத் தர்பணம் செய்கிறேன்; ரிஷிகளைத் தர்பணம் செய்கிறேன்; பித்ருக்களைத் தர்பணம் செய்கிறேன்."
      }
    ]
  },
  "yajnopavita-dharanam": {
    id: "yajnopavita-dharanam",
    titleDeva: "यज्ञोपवीतधारणम्",
    titleTamil: "யஞோபவீத தாரண விதி (பூணூல் அணிதல்)",
    pageNumber: 7,
    content: [
      {
        deva: "यज्ञोपवीतमिति मन्त्रस्य परब्रह्म ऋषिः । त्रिष्टुप् छन्दः । परमात्मा देवता ॥",
        tamilTranslit: "யஜ்ஞோபவீதமிதி மந்த்ரஸ்ய பரப்³ரஹ்ம ரு'ஷிஃ । த்ரிஷ்டுப் ச²ந்த³ஃ । பரமாத்மா தே³வதா ॥",
        tamilMeaning: "யஞோபவீத மந்திரத்திற்கு பரபிரம்மா ரிஷி, த்ரிஷ்டுப் சந்தஸ், பரமாத்மா தேவதை ஆவார்."
      },
      {
        deva: "यज्ञोपवीतं परमं पवित्रं प्रजापतेर्यत्सहजं पुरस्तात् । आयुष्यमग्र्यं प्रतिमुञ्च शुभ्रं यज्ञोपवीतं बलमस्तु तेजः ॥",
        tamilTranslit: "யஜ்ஞோபவீதம் பரமம் பவித்ரம் ப்ரஜாபதேர்யத்ஸஹஜம் புரஸ்தாத் । ஆயுஷ்யமக்³ர்யம் ப்ரதிமுஞ்ச ஶுப்⁴ரம் யஜ்ஞோபவீதம் ப³லமஸ்து தேஜஃ ॥",
        tamilMeaning: "பிரஜாபதியால் படைப்பின் தொடக்கத்தில் உண்டாக்கப்பட்டதும், மிகத் தூய்மையானதும், ஆயுள், பலம், தேஜஸைத் தருவதுமான இந்த யஞோபவீதத்தைச் தாரணம் செய்கிறேன்."
      }
    ]
  },
  "agnisandhanam-karika": {
    id: "agnisandhanam-karika",
    titleDeva: "अग्निसन्धानम् कारिका",
    titleTamil: "அக்னி சந்தானம் மற்றும் காரிகைகள்",
    pageNumber: 9,
    content: [
      {
        deva: "अग्निसन्धानं करिष्ये । परिसमूहनं परिस्तरणं च कृत्वा ।",
        tamilTranslit: "அக்³நிஸந்தா⁴நம் கரிஷ்யே । பரிஸமூஹநம் பரிஸ்தரணம் ச க்ரு'த்வா ।",
        tamilMeaning: "அக்னி சந்தானத்தைச் செய்கிறேன். அக்னி குண்டத்தைச் சுற்றிலும் நீர் தெளித்து, தர்பைப் பரப்பி அக்னியை ஆவாஹனம் செய்ய வேண்டும்."
      },
      {
        deva: "अग्निं प्रज्वलितं वन्दे जातवेदसमूर्जितम् ।",
        tamilTranslit: "அக்³நிம் ப்ரஜ்வலிதம் வந்தே³ ஜாதவேத³ஸமூர்ஜிதம் ।",
        tamilMeaning: "நன்கு ஜ்வலிக்கும் ஜாதவேதனாகிய அக்னி தேவனை வணங்குகிறேன்."
      }
    ]
  },
  "opasanam-samajapa": {
    id: "opasanam-samajapa",
    titleDeva: "औपासनम् सामजपे विशेषः",
    titleTamil: "ஔபாஸனம் மற்றும் ஸாம ஜப விசேஷம்",
    pageNumber: 17,
    content: [
      {
        deva: "सायं प्रातरौपासनं होमं करिष्ये ।",
        tamilTranslit: "ஸாயம் ப்ராதரௌபாஸநம் ஹோமம் கரிஷ்யே ।",
        tamilMeaning: "காலை மற்றும் மாலை வேளைகளில் செய்ய வேண்டிய ஔபாஸன ஹோமத்தைச் செய்கிறேன்."
      },
      {
        deva: "अग्नये स्वाहा । अग्नये इदं न मम ॥ प्रजापतये स्वाहा । प्रजापतये इदं न मम ॥",
        tamilTranslit: "அக்³நயே ஸ்வாஹா । அக்³நயே இத³ம் ந மம ॥ ப்ரஜாபதயே ஸ்வாஹா । ப்ரஜாபதயே இத³ம் ந மம ॥",
        tamilMeaning: "அக்னி தேவனுக்கு இந்த ஆஹுதி சமர்ப்பணம். பிரஜாபதி தேவனுக்கு இந்த ஆஹுதி சமர்ப்பணம்."
      }
    ]
  },
  "nandishraddha-punyahavachanam": {
    id: "nandishraddha-punyahavachanam",
    titleDeva: "नान्दीश्राद्धविधिः पुण्याहवाचनम्",
    titleTamil: "நாந்தீசிரார்த்த விதி மற்றும் புண்யாஹவாசனம்",
    pageNumber: 20,
    content: [
      {
        deva: "नान्दीमुखान् पितॄन् आवाहयिष्ये ।",
        tamilTranslit: "நாந்தீமுகா²ன் பித்ரூன் ஆவாஹயிஷ்யே ।",
        tamilMeaning: "மங்கள காரியங்களின் தொடக்கத்தில் பித்ருக்களின் ஆசியைப் பெற நாந்தீமுக பித்ருக்களை ஆவாஹனம் செய்கிறேன்."
      },
      {
        deva: "पुण्याहं भवन्तो ब्रुवन्तु । पुण्याहं अस्तु ॥ स्वस्ति भवन्तो ब्रुवन्तु । स्वस्ति अस्तु ॥",
        tamilTranslit: "புண்யாஹம் ப⁴வந்தோ ப்³ருவந்து । புண்யாஹம் அஸ்து ॥ ஸ்வஸ்தி ப⁴வந்தோ ப்³ருவந்து । ஸ்வஸ்தி அஸ்து ॥",
        tamilMeaning: "பெரியோர்களே! இந்நாளைப் புண்ணிய நாளாக ஆசீர்வதியுங்கள். புண்ணிய நாளாக ஆகட்டும்! மங்களமாக ஆகட்டும்!"
      }
    ]
  },
  "udakashanti": {
    id: "udakashanti",
    titleDeva: "उदकशान्ति प्रयोगः",
    titleTamil: "உதகசாந்தி பிரயோகம் (கலச பூசையும் வேத மந்தரங்களும்)",
    pageNumber: 26,
    content: [
      {
        deva: "कलशपूजां कृत्वा वेद मन्त्रैः उदकशान्तिं करिष्ये ।",
        tamilTranslit: "கலஶபூஜாம் க்ரு'த்வா வேத³ மந்த்ரைஃ உத³கஶாந்திம் கரிஷ்யே ।",
        tamilMeaning: "கலச பூஜை செய்து, வேத மந்திரங்களால் உதகசாந்தி ஹோமமும் ஜபமும் செய்கிறேன்."
      },
      {
        deva: "सुरास्त्वामभिषिञ्चन्तु ब्रह्मविष्णुशिवेश्वराः । वासुदेवो जगन्नाथः तथा शङ्खश्च माधवः ॥",
        tamilTranslit: "ஸுராஸ்த்வாமபி⁴ஷிஞ்சந்து ப்³ரஹ்மவிஷ்ணுஶிவேஶ்வராஃ । வாஸுதே³வோ ஜக³ந்நாத²ஃ ததா² ஶங்க²ஶ்ச மாத⁴வஃ ॥",
        tamilMeaning: "பிரம்மா, விஷ்ணு, சிவன், ஈஸ்வரன் மற்றும் ஜகந்நாதனாகிய வாசுதேவன் உங்களை இந்த உதகசாந்தி புனித நீரினால் அபிஷேகம் செய்யட்டும்."
      }
    ]
  },
  "jatakarma-namakaranam": {
    id: "jatakarma-namakaranam",
    titleDeva: "जातकर्म नामकरणम्",
    titleTamil: "ஜாதகர்மம் மற்றும் நாமகரணம் (குழந்தைப் பெயர் சூட்டுதல்)",
    pageNumber: 29,
    content: [
      {
        deva: "अङ्गदङ्गात् सम्भवसि हृदयादधिजायसे । आत्मा वै पुत्रनामासि स जीव शरदः शतम् ॥",
        tamilTranslit: "அங்கா³த³ங்கா³த் ஸம்ப⁴வஸி ஹ்ரு'த³யாத்³அதி⁴ஜாயஸே । ஆத்மா வை புத்ரநாமாஸி ஸ ஜீவ ஶரத³ஃ ஶதம் ॥",
        tamilMeaning: "என் உடல் உறுப்புகளிலிருந்தும் இதயத்திலிருந்தும் உதித்த என் மகனே! நீ என் ஆத்மாவே ஆவாய். நீ நூறாண்டுகள் நல்வாழ்வு வாழ்வாயாக."
      },
      {
        deva: "दशम्याम् उत्थाप्य पिता नाम करोति ।",
        tamilTranslit: "தஶம்யாம் உத்தா²ப்ய பிதா நாம கரோதி ।",
        tamilMeaning: "குழந்தை பிறந்த 10 அல்லது 11ஆம் நாளில் தந்தை குழந்தைக்குச் சாஸ்திரப்பூர்வமாகப் பெயர் சூட்ட வேண்டும்."
      }
    ]
  },
  "annaprasanam-choulam": {
    id: "annaprasanam-choulam",
    titleDeva: "अन्नप्राशन चौल प्रयोगौ",
    titleTamil: "அன்னப்ராசனம் மற்றும் சௌள பிரயோகம் (முதல் உணவு & முடி இறக்குதல்)",
    pageNumber: 35,
    content: [
      {
        deva: "षष्ठे मासि अन्नप्राशनं कुर्यात् ।",
        tamilTranslit: "ஷஷ்டே² மாஸி અન્નப்ராஶநம் குர்யாத் ।",
        tamilMeaning: "குழந்தை பிறந்த 6ஆம் மாதத்தில் அன்னப்ராசனம் (முதல் அன்னம் ஊட்டுதல்) செய்ய வேண்டும்."
      },
      {
        deva: "तृतीये वर्षे चौलकर्म प्रक्रियते ।",
        tamilTranslit: "த்ரு'தீயே வர்ஷே சௌளகர்ம ப்ரக்ரியதே ।",
        tamilMeaning: "3ஆம் ஆண்டில் குழந்தைக்குச் சௌளம் (முடி இறக்கி குடுமி வைத்தல்) செய்ய வேண்டும்."
      }
    ]
  },
  "upanayana-prayogah": {
    id: "upanayana-prayogah",
    titleDeva: "उपनयन प्रयोगः अष्टौ व्रतानि",
    titleTamil: "உபநயன பிரயோகம் (பூணூல் கல்யாணம் & பிரம்மச்சரிய விரதங்கள்)",
    pageNumber: 37,
    content: [
      {
        deva: "अष्टमे वर्षे ब्राह्मणम् उपनयीत ।",
        tamilTranslit: "அஷ்டமே வர்ஷே ப்³ராஹ்மணம் உபநயீத ।",
        tamilMeaning: "8ஆம் வயதில் பிராமணச் சிறுவனுக்கு உபநயனம் செய்ய வேண்டும்."
      },
      {
        deva: "ॐ तत्सवितुर्वरेण्यं भर्गो देवस्य धीमहि । धियो यो नः प्रचोदयात् ॥",
        tamilTranslit: "ஓம் தத்ஸவிதுர்வரேண்யம் ப⁴ர்கோ³ தே³வஸ்ய தீ⁴மஹி । தீ⁴யோ यो நஃ ப்ரசோத³யாத் ॥",
        tamilMeaning: "எங்கள் அறிவை நல்வழியில் தூண்டுகின்ற ஒளிமயமான அந்தச் சவிதா தேவனைத் தியானிக்கிறோம் (காயத்ரீ மஹாமந்திரம்)."
      }
    ]
  },
  "samavartanam": {
    id: "samavartanam",
    titleDeva: "समावर्तन प्रयोगः",
    titleTamil: "சமாவர்த்தன பிரயோகம் (வேதக் கல்வி நிறைவுச் சடங்கு)",
    pageNumber: 55,
    content: [
      {
        deva: "वेदव्रतानि समाप्य समावर्तनं कुर्यात् ।",
        tamilTranslit: "வேத³வ்ரதாநி ஸமாப்ய ஸமாவர்தநம் குர்யாத் ।",
        tamilMeaning: "வேத விரதங்களை நிறைவு செய்து பிரம்மச்சாரி ஸ்நாதகனாகச் சமாவர்த்தனம் செய்துகொள்ள வேண்டும்."
      }
    ]
  },
  "vivaha-prayogah": {
    id: "vivaha-prayogah",
    titleDeva: "उद्वाह प्रयोगः विवाहहोमः",
    titleTamil: "விவாஹப் பிரயோகம் (திருமணச் சடங்குகள், கன்னிகாதானம், சப்தபதி)",
    pageNumber: 57,
    content: [
      {
        deva: "गृभ्णामि ते सौभगत्वाय हस्तम् मया पत्या जरदष्टिर्यथासः ।",
        tamilTranslit: "க்ரு'ப்⁴ணாமி தே ஸௌப⁴க³த்வாய ஹஸ்தம் மயா பத்யோ ஜரத³ஷ்டிர்யதா²ஸஃ ।",
        tamilMeaning: "உன் நல்வாழ்வுக்காக உன் கரத்தைப் பற்றுகிறேன். கணவனான என்னுடன் நீ முதுமை வரை இன்புற்று வாழ்வாயாக (பாணிகிரஹணம்)."
      },
      {
        deva: "एकमिषे विष्णुस्त्वान्त्वेतु । द्वे ऊर्जे विष्णुस्त्वान्त्वेतु । त्रीणि व्रताय विष्णुस्त्वान्त्वेतु । चत्वारि मायोभवाय विष्णुस्त्वान्त्वेतु । पञ्च पशुभ्यो विष्णुस्त्वान्त्वेतु । षड् ऋतुभ्यो विष्णुस्त्वान्त्वेतु । सप्ता सप्थिभ्यो विष्णुस्त्वान्त्वेतु । सखा सप्तपदा भव ॥",
        tamilTranslit: "ஏகமிஷே விஷ்ணுஸ்த்வாந்த்வேது... ஸகா² ஸப்தபதா³ ப⁴வ ॥",
        tamilMeaning: "ஏழு அடிகள் எடுத்து வைத்து சப்தபதி செய்கிறோம். நீ என் உயிர் நண்பனாகவும் வாழ்வின் துணையாகவும் ஆகிறாய்."
      }
    ]
  },
  "ritu-shanti-seemantham": {
    id: "ritu-shanti-seemantham",
    titleDeva: "पुंसवन सीमन्तोन्नयन प्रयोगौ",
    titleTamil: "பும்ஸவனம் மற்றும் சீமந்தோன்னயனம் (வளைகாப்பு & கர்ப்பச் சடங்குகள்)",
    pageNumber: 83,
    content: [
      {
        deva: "तृतीये मासि पुंसवनम् । षष्ठे सप्तमे वा मासि सीमन्तोन्नयनम् ।",
        tamilTranslit: "த்ரு'தீயே மாஸி பும்ஸவநம் । ஷஷ்டே² ஸப்தமே வா மாஸி ஸீமந்தோந்நயநம் ।",
        tamilMeaning: "கர்ப்பத்தின் 3ஆம் மாதத்தில் பும்ஸவனமும், 6 அல்லது 7ஆம் மாதத்தில் சீமந்தோன்னயனமும் செய்ய வேண்டும்."
      }
    ]
  },
  "vaishvadeva-prayogah": {
    id: "vaishvadeva-prayogah",
    titleDeva: "वैश्वदेव प्रयोगः स्थालीपाकः",
    titleTamil: "வைஸ்வதேவ பிரயோகம் மற்றும் ஸ்தாலீபாகம் (தினசரி பஞ்ச மஹா யக்ஞம்)",
    pageNumber: 87,
    content: [
      {
        deva: "अन्नस्य पक्वस्य वैश्वदेवं होमं कुर्यात् ।",
        tamilTranslit: "அந்நஸ்ய பக்வஸ்ய வைஶ்வதே³வம் ஹோமம் குர்யாத் ।",
        tamilMeaning: "சமைத்த உணவைக் கொண்டு தினமும் வைஸ்வதேவ ஹோமமும் பஞ்ச மஹா யக்ஞமும் செய்ய வேண்டும்."
      }
    ]
  }
};
